import {
  defaultDropAnimation,
  DropAnimation,
  MeasuringStrategy,
  Modifier,
} from '@dnd-kit/core';
import { AnimateLayoutChanges } from '@dnd-kit/sortable';

export const measuring = {
  droppable: {
    strategy: MeasuringStrategy.Always,
  },
};

export const dropAnimation: DropAnimation = {
  ...defaultDropAnimation,
};

export const adjustTranslate: Modifier = ({ transform }) => {
  return {
    ...transform,
    y: transform.y - 15,
  };
};

export const animateLayoutChanges: AnimateLayoutChanges = ({
  isSorting,
  wasDragging,
}) => (isSorting || wasDragging ? false : true);
